import {HardwareItem} from "../../../../api/Hardware";
import {sum} from "nate-react-api-helpers";

// the hinge product lines within a hardware group: auto-qty hinge products that
// are actually specced (some active/inactive qty) and not archived. Shared by the
// Multi-Hinge config dialog and the elevation tool's per-location hinge override.
//
// `leaf` narrows the "specced" test to one leaf: "active" keeps only products with
// active hinges, "inactive" only those with inactive hinges. Omitted (both leaves)
// keeps anything with hinges on either — used where the leaf is irrelevant.
export function getHingeLines<T extends Pick<HardwareItem, "productIsAutoQtyHinge" | "activeQty" | "inactiveQty" | "archived">>(value: T[], leaf?: "active" | "inactive"): T[] {
    return value.filter(h => {
        if(!h.productIsAutoQtyHinge || h.archived !== false) return false;
        if(leaf === "active") return h.activeQty > 0;
        if(leaf === "inactive") return h.inactiveQty > 0;
        return h.activeQty > 0 || h.inactiveQty > 0;
    });
}

// the "main" hinge product: the hinge line carrying the most total hinges (active +
// inactive). Used as the default when no per-location override is set. Non-mutating.
export function calcDefaultHingeProduct(hinges: Pick<HardwareItem, "product" | "hingeActiveQtys" | "hingeInactiveQtys">[]): number | undefined {
    let best: typeof hinges[number] | undefined;
    let bestVal = -Infinity;

    for(const h of hinges) {
        const val = sum(h.hingeActiveQtys || []) + sum(h.hingeInactiveQtys || []);
        if(val > bestVal) {
            bestVal = val;
            best = h;
        }
    }

    return best?.product;
}
